import { authRoles } from 'app/auth/authRoles';
import Loadable from 'app/components/Loadable';
import { lazy } from 'react';

const SlotAnalytics = Loadable(lazy(() => import('./SlotAnalytics')));
const slotRoutes = [
  { path: '/slot/default', element: <SlotAnalytics />, auth: authRoles.admin },
];
export default slotRoutes;
